<template>
  <app-toast
    class="confirm-subscription"
    :message="message"
  >
    <div
      class="toast-body"
      v-html="$t('toast.confirm-subscription')"
    />
  </app-toast>
</template>

<script>
  import appToast from '@/components/app-toast'

  export default {
    name: 'ConfirmSubscription',

    components: {
      'app-toast': appToast
    },

    props: {
      message: Object
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
</style>
